// tktuner logout — revokes the device token (best-effort) and deletes credentials.
import pc from "picocolors";
import { apiCall } from "../lib/api-client";
import { deleteCredentials, readCredentials } from "../lib/credentials";

export async function logout(): Promise<void> {
  const creds = readCredentials();
  if (!creds) {
    console.log("Not logged in.");
    return;
  }
  try {
    await apiCall("POST", creds.apiUrl, "/v1/device/revoke-self", { token: creds.deviceToken });
  } catch {
    // offline or already revoked — deleting local credentials is what matters
  }
  deleteCredentials();
  console.log(`${pc.green("Logged out.")} Device ${pc.bold(creds.deviceName)} was disconnected.`);
}
